'use client';
import { getRoundedVariantSizes } from './getRoundedVariantSizes/getRoundedVariantSizes.js';
import { getCircularVariantSizes } from './getCircularVariantSizes/getCircularVariantSizes.js';
import { getTypographyVariantSizes } from './getTypographyVariantSizes/getTypographyVariantSizes.js';
import { getRectangularVariantSizes } from './getRectangularVariantSizes/getRectangularVariantSizes.js';

/**
 * Задаёт форму скелетона на основе варианта.
 * Вариант по-умолчанию - `rounded`.
 * */ var getSizeStyles = function(theme, params, variations) {
    switch(variations.variant){
        case "rectangular":
            return getRectangularVariantSizes(theme, params);
        case "text":
            return getTypographyVariantSizes(theme, theme.typography.variants.text.sizes, params, variations.size);
        case "heading":
            return getTypographyVariantSizes(theme, theme.typography.variants.heading.sizes, params, variations.size);
        case "circular":
            return getCircularVariantSizes(params);
        case "rounded":
            return getRoundedVariantSizes(theme, params);
        default:
            return getRoundedVariantSizes(theme, params);
    }
};

export { getSizeStyles };
